import { render } from "./homeNotice.vue?vue&type=template&id=011f4630&scoped=true"
import script from "./homeNotice.vue?vue&type=script&lang=js"
export * from "./homeNotice.vue?vue&type=script&lang=js"

import "./homeNotice.vue?vue&type=style&index=0&id=011f4630&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011f4630"]])

export default __exports__